export const appVersion = '2.6.0.27326'; 
